<template>
<div id="" class="grey lighten-4">
  <send-notification></send-notification>
  <v-container fluid class="">
    <v-row>
      <v-col cols="12" md="3" lg="3" xl="2" class="pt-4" v-if="$store.state.app.display !=='xs' && $store.state.app.display !=='sm'">
        <admin-menu></admin-menu>
      </v-col>

      <v-col cols="12" md="9" lg="9" xl="10" class="pt-4">
        <router-view></router-view>
      </v-col>

    </v-row>
  </v-container>
</div>
</template>
<script>
import store from "@/store"
import menu from "./menu"
import send_notification from "./send_notification"

export default {
  name: "",
  components: {
    adminMenu: menu,
    sendNotification: send_notification
  },
  beforeRouteEnter(to, from, next) {
    if (store.getters['account/isAdmin']) {
      next()
    } else {
      next("/")
    }
  },
  beforeRouteUpdate(to, from, next) {
    next()
  },
  data: () => ({
    show_menu: true,

  })
}
</script>
<style lang="scss" scoped>
</style>
